/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Configuration, LogLevel } from "@azure/msal-browser"
import * as dotEnv from "lib/dotEnv"

export const MsalConfig: Configuration = {
	auth: {
		clientId: dotEnv.Get("CLIENT_ID"),
		authority: dotEnv.Get("AUTHORITY"),
		redirectUri: window.location.origin,
	},
	cache: {
		cacheLocation: "localStorage", // This configures where your cache will be stored
		storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {
		loggerOptions: {
			logLevel: dotEnv.AuthConfig.logLevel,
			loggerCallback: (level: LogLevel, message: string, containsPii: bool) => {
				if (containsPii) {
					return
				}
				/* eslint-disable */
				switch (level) {
					case LogLevel.Error:
						console.error(message)
						return
					case LogLevel.Info:
						// console.info(message);
						return
					case LogLevel.Verbose:
						// console.debug(message);
						return
					case LogLevel.Warning:
						// console.warn(message);
						return
				}
				/* eslint-enable */
			},
		},
	},
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const MsalLoginReq = {
	scopes: ["openid", "profile", "User.Read", "AccessToken.Read"],
}

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const MsalGraphConfig = {
	graphMeEndpoint: "Enter_the_Graph_Endpoint_Here/v1.0/me",
}
